import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('remarkTemplateListStore')
@observer
class RemarkTemplateList extends Component {
  render() {
    const { remarkTemplateListStore, location } = this.props
    const { isFetching } = remarkTemplateListStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default RemarkTemplateList;
